<template>
  <div>
    <template v-if="!inLoading">
      <v-select
        v-if="displayable"
        v-model="model"
        :clearable="clearable"
        :disabled="disabled"
        item-text="userFullname"
        item-value="userId"
        :items="filteredStaffs || items"
        :label="label"
        :placeholder="placeholder"
        :readonly="readonly"
        :rules="rules"
        :menu-props="{ bottom: true, offsetY: true }"
        return-object
      />
      <v-text-field
        v-else
        readonly
        disabled
        class="v-content"
        :label="label"
        :value="'데이터 불러오기 실패'"
      />
    </template>
    <template v-else>
      <v-text-field
        readonly
        class="v-content"
        :label="label"
        :value="model.userFullname"
      />
    </template>
  </div>
</template>

<script>
    import MFormStaffPicker from "@/assets/plugins/mps-form/providers/MFormStaffPicker";

    export default {
        name: "MFormVuetifyStaffPicker",
        mixins: [MFormStaffPicker]
    }
</script>
